import { NodeViewWrapper } from "@tiptap/react";
import type { Attachment } from "@/react/types/Attachment";
import { TranscriptsPlayer } from "@circle-react-uikit/TranscriptsPlayer";

interface VideoRendererProps {
  attachment: Attachment;
  isTranscodingEnabled?: boolean;
}

export const VideoRenderer = ({
  attachment,
  isTranscodingEnabled = false,
}: VideoRendererProps) => (
  <NodeViewWrapper as="div" id="file-wrapper">
    <TranscriptsPlayer
      src={attachment.url}
      type={attachment.content_type}
      mediaTranscoding={attachment.media_transcoding}
      mediaTranscriptId={attachment.media_transcript_id}
      isDownloadable={attachment.is_downloadable}
      isTranscodingEnabled={isTranscodingEnabled}
      poster={attachment.image_variants?.thumbnail}
      chaptersUrl={attachment.chapters_url}
      previewThumbnailsUrl={attachment.preview_thumbnails_url}
      signedId={attachment.signed_id}
      variants={attachment.video_variants}
    />
  </NodeViewWrapper>
);
